import { mapRange, roundDownWTN } from "./UtilityFunctions";
import { ScaleConfiguration } from "./WTNScaleCanvas.types";
import { polarToCartesian } from "./UtilityFunctions";

export const drawScale = ({
  ctx,
  angle,
  config,
}: {
  ctx: CanvasRenderingContext2D;
  angle: number;
  config: ScaleConfiguration;
}) => {
  ctx.clearRect(0, 0, config.baseUnit, config.baseUnit);
  ctx.fillStyle = "white";
  ctx.fillRect(0, 0, config.baseUnit, config.baseUnit);

  drawCircularBg({
    ctx,
    circleCenterX: config.baseUnit / 2,
    circleCenterY: config.baseUnit / 2,
    radius: config.radius,
    startAngle: config.startingAngle,
    endAngle: config.staticDrawingFinishAngle,
    fillColor: config.backgroundColor,
    strokeColor: config.greyColor,
    lineWidth: config.lineWidth,
  });

  drawScore({
    ctx,
    startingAngle: config.startingAngle,
    radians: angle,
    primaryGradientColor: config.primaryColor,
    secondaryGradientColor: config.secondaryColor,
    scoreFontSize: config.scoreFontsize,
    scoreFontFamily: config.textFontFamily,
    scoreXpos: config.scoreXpos,
    scoreYpos: config.scoreYpos,
    baseUnit: config.baseUnit,
    confidence: config.confidence,
    sourceIsPsq: config.sourceIsPsq,
    psqRatingColor: config.tertiaryColor,
    decimalPoints: config.decimalPoints,
  });

  drawCircleGradient({
    ctx,
    x: config.baseUnit / 2,
    y: config.baseUnit / 2,
    radius: config.radius,
    startAngle: config.startingAngle,
    finishAngle: angle,
    gradientX0: config.baseUnit / 2 - config.baseUnit / 10,
    gardientY0: config.baseUnit - config.baseUnit / 4,
    gradientX1:
      polarToCartesian({ r: config.radius, angle }).x + config.baseUnit / 2,
    gardientY1:
      polarToCartesian({ r: config.radius, angle }).y + config.baseUnit / 2,
    gradientPrimaryColor: config.primaryColor,
    gradientSecondaryColor: config.secondaryColor,
    lineWidth: config.lineWidth,
  });

  if (config.scoreLabels) {
    drawText({
      ctx,
      text: "40",
      textColor: config.tertiaryColor,
      textFontWeight: "600",
      textFontSize: config.scoreSignsFontsize.toString(),
      textFontFamily: config.textFontFamily,
      textAlignment: "center",
      xPos: config.baseUnit / 2 - config.baseUnit / 8.5,
      yPos: config.baseUnit - config.baseUnit / 3.45,
    });
    drawText({
      ctx,
      text: "1",
      textColor: config.tertiaryColor,
      textFontWeight: "600",
      textFontSize: config.scoreSignsFontsize.toString(),
      textFontFamily: config.textFontFamily,
      textAlignment: "center",
      xPos: config.baseUnit / 2 + config.baseUnit / 8.5,
      yPos: config.baseUnit - config.baseUnit / 3.45,
    });
  }
};

export const drawProScale = ({
  ctx,
  config,
}: {
  ctx: CanvasRenderingContext2D;
  config: ScaleConfiguration;
}) => {
  ctx.clearRect(0, 0, config.baseUnit, config.baseUnit);
  ctx.fillStyle = "white";
  ctx.fillRect(0, 0, config.baseUnit, config.baseUnit);

  drawCircularBg({
    ctx,
    circleCenterX: config.baseUnit / 2,
    circleCenterY: config.baseUnit / 2,
    radius: config.radius,
    startAngle: config.startingAngle,
    endAngle: config.staticDrawingFinishAngle,
    fillColor: config.backgroundColor,
    strokeColor: config.greyColor,
    lineWidth: config.lineWidth,
  });

  drawTextWithGradient({
    ctx,
    text: "Pro Zone",
    textFontWeight: "700",
    textFontSize: config.proTextFontSize.toString(),
    textFontFamily: config.textFontFamily,
    textAlignment: "center",
    primaryGradientColor: config.primaryColor,
    secondaryGradientColor: config.secondaryColor,
    xPos: config.baseUnit / 2,
    yPos: config.baseUnit / 2,
  });

  drawCircleGradient({
    ctx,
    x: config.baseUnit / 2,
    y: config.baseUnit / 2,
    radius: config.radius,
    startAngle: config.startingAngle,
    finishAngle: config.staticDrawingFinishAngle,
    gradientX0: config.baseUnit / 2,
    gardientY0: config.baseUnit / 5,
    gradientX1: config.baseUnit / 2,
    gardientY1: config.baseUnit - config.baseUnit / 5,
    gradientPrimaryColor: config.primaryColor,
    gradientSecondaryColor: config.secondaryColor,
    lineWidth: config.lineWidth,
  });
};

export const drawNoMatchesScale = ({
  ctx,
  config,
  mode,
}: {
  ctx: CanvasRenderingContext2D;
  config: ScaleConfiguration;
  mode: "noSingles" | "noDoubles";
}) => {
  ctx.clearRect(0, 0, config.baseUnit, config.baseUnit);
  ctx.fillStyle = "white";
  ctx.fillRect(0, 0, config.baseUnit, config.baseUnit);

  drawCircularBg({
    ctx,
    circleCenterX: config.baseUnit / 2,
    circleCenterY: config.baseUnit / 2,
    radius: config.radius,
    startAngle: config.startingAngle,
    endAngle: config.staticDrawingFinishAngle,
    fillColor: config.backgroundColor,
    strokeColor: config.greyColor,
    lineWidth: config.lineWidth,
  });

  if (mode === "noSingles") {
    drawText({
      ctx,
      text: "No Singles",
      textColor: config.primaryColorAlt,
      textFontWeight: "600",
      textFontSize: config.noMatchesFontsize.toString(),
      textFontFamily: config.textFontFamily,
      textAlignment: "center",
      xPos: config.baseUnit / 2,
      yPos: config.baseUnit / 2 - config.baseUnit / 14.5,
    });
  }
  if (mode === "noDoubles") {
    drawText({
      ctx,
      text: "No Doubles",
      textColor: config.primaryColorAlt,
      textFontWeight: "600",
      textFontSize: config.noMatchesFontsize.toString(),
      textFontFamily: config.textFontFamily,
      textAlignment: "center",
      xPos: config.baseUnit / 2,
      yPos: config.baseUnit / 2 - config.baseUnit / 14.5,
    });
  }

  drawText({
    ctx,
    text: "match data",
    textColor: config.primaryColorAlt,
    textFontWeight: "600",
    textFontSize: config.noMatchesFontsize.toString(),
    textFontFamily: config.textFontFamily,
    textAlignment: "center",
    xPos: config.baseUnit / 2,
    yPos: config.baseUnit / 2 - config.baseUnit / 65,
  });

  if (config.scoreLabels) {
    drawText({
      ctx,
      text: "40",
      textColor: config.tertiaryColor,
      textFontWeight: "600",
      textFontSize: config.scoreSignsFontsize.toString(),
      textFontFamily: config.textFontFamily,
      textAlignment: "center",
      xPos: config.baseUnit / 2 - config.baseUnit / 8.5,
      yPos: config.baseUnit - config.baseUnit / 3.45,
    });
    drawText({
      ctx,
      text: "1",
      textColor: config.tertiaryColor,
      textFontWeight: "600",
      textFontSize: config.scoreSignsFontsize.toString(),
      textFontFamily: config.textFontFamily,
      textAlignment: "center",
      xPos: config.baseUnit / 2 + config.baseUnit / 8.5,
      yPos: config.baseUnit - config.baseUnit / 3.45,
    });
  }
};

export const drawCircularBg = ({
  ctx,
  circleCenterX,
  circleCenterY,
  radius,
  startAngle,
  endAngle,
  fillColor,
  strokeColor,
  lineWidth,
}: {
  ctx: CanvasRenderingContext2D;
  circleCenterX: number;
  circleCenterY: number;
  radius: number;
  startAngle: number;
  endAngle: number;
  fillColor: string;
  strokeColor: string;
  lineWidth: number;
}) => {
  ctx.beginPath();
  ctx.arc(circleCenterX, circleCenterY, radius, startAngle, endAngle);
  ctx.fillStyle = fillColor;
  //ctx.fill();
  ctx.lineWidth = lineWidth;
  ctx.strokeStyle = strokeColor;
  ctx.stroke();
};

export const drawText = ({
  ctx,
  text,
  textColor,
  textFontWeight,
  textFontSize,
  textFontFamily,
  textAlignment,
  xPos,
  yPos,
}: {
  ctx: CanvasRenderingContext2D;
  text: string;
  textColor: string;
  textFontWeight: string;
  textFontSize: string;
  textFontFamily: string;
  textAlignment: CanvasTextAlign;
  xPos: number;
  yPos: number;
}) => {
  ctx.fillStyle = textColor;
  ctx.font = ` ${textFontWeight} ${textFontSize}px ${textFontFamily}`;
  ctx.textAlign = textAlignment;
  ctx.fillText(text, xPos, yPos);
};

export const drawTextWithGradient = ({
  ctx,
  text,
  textFontWeight,
  textFontSize,
  textFontFamily,
  textAlignment,
  primaryGradientColor,
  secondaryGradientColor,
  xPos,
  yPos,
}: {
  ctx: CanvasRenderingContext2D;
  text: string;
  textFontWeight: string;
  textFontSize: string;
  textFontFamily: string;
  textAlignment: CanvasTextAlign;
  primaryGradientColor: string;
  secondaryGradientColor: string;
  xPos: number;
  yPos: number;
}) => {
  const textGradient = ctx.createLinearGradient(
    xPos - xPos / 5,
    yPos - yPos / 3,
    xPos + xPos / 3,
    yPos
  );
  textGradient.addColorStop(0, primaryGradientColor);
  textGradient.addColorStop(1, secondaryGradientColor);

  ctx.fillStyle = textGradient;
  ctx.font = ` ${textFontWeight} ${textFontSize}px ${textFontFamily}`;
  ctx.textAlign = textAlignment;
  ctx.fillText(text, xPos, yPos);
};
export const drawNeedle = (
  ctx: CanvasRenderingContext2D,
  color: string,
  cx: number,
  cy: number,
  radius: number,
  radianAngle: number,
  width: number
) => {
  ctx.translate(cx, cy);
  ctx.rotate(radianAngle);
  //draw triangle
  ctx.beginPath();
  ctx.moveTo(0, -width);
  ctx.lineTo(radius, 0);
  ctx.lineTo(0, width);
  ctx.rotate(-radianAngle);
  ctx.translate(-cx, -cy);

  ctx.fillStyle = color;
  ctx.fill();

  //central circle
  ctx.beginPath();
  ctx.arc(cx, cy, width, 0, Math.PI * 2);
  ctx.fill();
};

export const drawCircleGradient = ({
  ctx,
  x,
  y,
  radius,
  startAngle,
  finishAngle,
  gradientX0,
  gardientY0,
  gradientX1,
  gardientY1,
  gradientPrimaryColor,
  gradientSecondaryColor,
  lineWidth,
}: {
  ctx: CanvasRenderingContext2D;
  x: number;
  y: number;
  radius: number;
  startAngle: number;
  finishAngle: number;
  gradientX0: number;
  gardientY0: number;
  gradientX1: number;
  gardientY1: number;
  gradientPrimaryColor: string;
  gradientSecondaryColor: string;
  lineWidth: number;
}) => {
  const gradient: CanvasGradient = ctx.createLinearGradient(
    gradientX0,
    gardientY0,
    gradientX1,
    gardientY1
  );
  gradient.addColorStop(0, gradientPrimaryColor);
  gradient.addColorStop(1, gradientSecondaryColor);

  ctx.beginPath();
  ctx.strokeStyle = gradient;
  ctx.lineWidth = lineWidth;
  ctx.arc(x, y, radius, startAngle, finishAngle);
  ctx.stroke();
};

export const drawScore = ({
  ctx,
  startingAngle,
  radians,
  primaryGradientColor,
  secondaryGradientColor,
  scoreFontSize,
  scoreFontFamily,
  scoreXpos,
  scoreYpos,
  baseUnit,
  confidence,
  sourceIsPsq,
  psqRatingColor,
  decimalPoints,
}: {
  ctx: CanvasRenderingContext2D;
  startingAngle: number;
  radians: number;
  primaryGradientColor: string;
  secondaryGradientColor: string;
  scoreFontSize: number;
  scoreFontFamily: string;
  scoreXpos: number;
  scoreYpos: number;
  baseUnit: number;
  confidence: number;
  sourceIsPsq: boolean;
  psqRatingColor: string;
  decimalPoints: number;
}) => {
  const mainScoreFont = `bold ${scoreFontSize}px ${scoreFontFamily}`;
  const decimalScoreFont = `bold ${scoreFontSize * 0.55}px ${scoreFontFamily}`;
  const score: string = mapRange({
    value: radians,
    low1: startingAngle,
    high1: 2 * Math.PI + Math.PI / 2 - Math.PI / 10,
    low2: 40,
    high2: 1,
  }).toString();
  const roundedScore: string = roundDownWTN({
    wtn: parseFloat(score),
    decimalPoints,
  });
  const textGradient = ctx.createLinearGradient(
    scoreXpos,
    scoreYpos + 5,
    scoreXpos,
    scoreYpos - 35
  );

  textGradient.addColorStop(0, primaryGradientColor);
  textGradient.addColorStop(1, secondaryGradientColor);

  if (sourceIsPsq) {
    ctx.fillStyle = psqRatingColor;
  } else {
    ctx.fillStyle = textGradient;
  }

  ctx.font = mainScoreFont;
  ctx.textAlign = "center";

  const img = new Image();

  let imgDimensions = {
    dw: Math.ceil(baseUnit / 28),
    dh: Math.ceil(baseUnit / 28),
  };

  const blueRibbon =
    "data:image/png;base64,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";
  const grayRibbon =
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAANbSURBVHgB1VjRUdtAEN09JV98hFSANcEQfxEqiF1BSAXYFYRUgOiAVIBdQaCCOBUAX56YMBIVxIwhH3Gkza4sySfHlmTrsIc34/GdtDo93e3uvT0EA+jf3n0CIkfaiHhafbN1AiWBUBI3N26dEL/p13yiRq1qd6EEXhQximbkgJueb9FJzba9+F5A0MSpz7MQD/mvG/d7rluxAjwGgooCbG9vb3UgB7kz1u+7TVB4pl3yeHDH94N7fvoAVUhiFtpI1CGl9vijjrhfgeRj6PPbqn0KpYj99GSZ6mAQTOyCiR1k2SjIBV2DYSjEX7k2eQYUwCYYRhDQfZ5NJjFxWvah92AYiv1Sxs6ySfmYRB8R1fniQL5KjR3b+IxF8PjXjd6zNx2tCbEZ0bdy6NE6Wcr5Yb8ycFB8SNpxgwK6g/XDixsJscAHh7Qbq4a82x9RsscmxGo122PH/wKGwSvReRzSa27ljI2OcIBpYgIL4AoMgiPrfHfHbu7v2wMevJ1lS4QDvZ8iJhsymALB1cOQWtIMc5aPX7PMFQapLSpMFyJdQpVgKjKZ1OMDNWSmLl13c+MvyyKEdwWeDDf+KksmvLm9O6ZI5K2ZVALJZ8jqQTbUYtmdX0pAFyxTD1GTMZPb4P0e0n4ZUhEGBdSF/mZq7VZtJxhRYzq1SF+uh47O2BCfWo6UjDVQPG3F9Tmq0AclrHVyMak43HkVZGurw7JgPwudv8fOrwo6PxcbTlxs9HosmV/iGSfG1hSpJiyHNtcLHakXUuriR99tL0pOR1lSO9uVVtxJ+5iCcygAiWKJZv1a1G/CkpCZ0vupKglFrRYMh4gckB9coKUOaVxwLA1eOgmUrtYfIyyx/LA+rMB6IKVhIy4Nk/lRI3BgfaQE49ozQkKMnX4L1g2aTMxEj3GtB2sGse6P26l00WPdb3G64ALhGmWb4goJn255peCRRLrJxcgrjsrvenWeWYlHCfQSDFdK0zvFLGQmh/GDlHsAsih4NrpZpATPsxIPDXj9wTCkwM21yTMQp9T7oaJAPJLDOSk0Mh5ts3b76AfU+l8iTaJvHgqdKMbRytae/4cP7jT/mLPxpzZkCSJlgSO5MjqCOjVCLJM0SybrCY46F1OwMyAEaCw2RbkORK+XJSX4B/QIvg7xBUtYAAAAAElFTkSuQmCC";
  const psqLogo =
    "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAzMCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxyZWN0IHg9Ii41IiB3aWR0aD0iMjkiIGhlaWdodD0iMTYiIHJ4PSI0IiBmaWxsPSIjMDAzQTcwIi8+CiAgICA8cGF0aCBkPSJNOC40ODIgMTEgNi45OTcgOC41MjVoLS41NThWMTFoLTEuMjdWNC42NDZoMi40MjJjLjczOCAwIDEuMjk5LjE4IDEuNjgzLjU0LjM5LjM2LjU4NS44MzQuNTg1IDEuNDIyIDAgLjQ4LS4xMzUuODgyLS40MDUgMS4yMDYtLjI2NC4zMjQtLjY0OC41NC0xLjE1Mi42NDhMOS44ODYgMTFIOC40ODJ6TTYuNDM5IDcuNjUyaDEuMDQ0Yy43MjYgMCAxLjA4OS0uMzIxIDEuMDg5LS45NjMgMC0uMzA2LS4wOS0uNTQzLS4yNy0uNzExLS4xNzQtLjE3NC0uNDQ3LS4yNjEtLjgyLS4yNjFINi40NHYxLjkzNXptMTEuMzA2LTIuOTM0VjExaC0xLjI2VjYuNjE3TDE0Ljg3NCAxMWgtMS4wOThsLTEuNjExLTQuMzY1VjExaC0xLjI3VjQuNzE4aDEuNTRsMS45MDggNC43MjUgMS44NzItNC43MjVoMS41M3ptNC4yNzItLjEzNWMuNzc0IDAgMS40MTYuMTkyIDEuOTI2LjU3Ni41MS4zNzguODM3Ljg5MS45OCAxLjUzOWgtMS4zMzFhMS40OCAxLjQ4IDAgMCAwLS42MDMtLjY4NCAxLjczOSAxLjczOSAwIDAgMC0uOTYzLS4yNjFjLS4zNjYgMC0uNjkuMDg0LS45NzIuMjUyYTEuNyAxLjcgMCAwIDAtLjY1Ny43MmMtLjE1Ni4zMTItLjIzNC42NzgtLjIzNCAxLjA5OCAwIC42NjYuMTc3IDEuMTg1LjUzIDEuNTU3LjM2LjM3Mi44NS41NTggMS40NjguNTU4LjQ1NiAwIC44NDYtLjEzNSAxLjE3LS40MDUuMzMtLjI3LjU0My0uNjQ1LjYzOS0xLjEyNWgtMi4xNTF2LS45MDloMy4yMTN2MS4yMjRhMi45NiAyLjk2IDAgMCAxLS41MzEgMS4xNjFjLS4yNTguMzU0LS42LjYzOS0xLjAyNi44NTUtLjQyLjIxLS45MDMuMzE1LTEuNDUuMzE1LS42MjMgMC0xLjE3NS0uMTM1LTEuNjU1LS40MDVhMi44OTggMi44OTggMCAwIDEtMS4xMDctMS4xNDNjLS4yNTgtLjQ5Mi0uMzg3LTEuMDUzLS4zODctMS42ODMgMC0uNjMuMTI5LTEuMTg4LjM4Ny0xLjY3NGEyLjg4MiAyLjg4MiAwIDAgMSAxLjEwNy0xLjE1MmMuNDc0LS4yNzYgMS4wMjMtLjQxNCAxLjY0Ny0uNDE0eiIgZmlsbD0iI2ZmZiIvPgo8L3N2Zz4K";

  if (sourceIsPsq) {
    img.src = psqLogo;
    imgDimensions = {
      dw: Math.ceil((1.625 * baseUnit) / 30),
      dh: Math.ceil(baseUnit / 30),
    };
  } else {
    confidence <= 60 ? (img.src = grayRibbon) : (img.src = blueRibbon);
  }

  const [mainScore, decimal] = roundedScore.split(".");
  const decimalScore = "." + decimal;
  const mainScoreWidth = ctx.measureText(mainScore).width;
  ctx.font = decimalScoreFont;
  const {
    width: decimalScoreWidth,
    actualBoundingBoxAscent,
    actualBoundingBoxDescent,
  } = ctx.measureText(decimalScore);
  // if `actualBoundingBoxAscent` is not supported we fall back
  const decimalScoreHeight = actualBoundingBoxAscent
    ? actualBoundingBoxAscent + actualBoundingBoxDescent
    : baseUnit * 0.047;
  const totalScoreWidth = mainScoreWidth + decimalScoreWidth;
  const mainScoreXPos = baseUnit / 2 - totalScoreWidth / 2 + mainScoreWidth / 2;
  const decimalScoreXPos =
    mainScoreXPos + mainScoreWidth / 2 + decimalScoreWidth / 2;
  const imgXPos = decimalScoreXPos + decimalScoreWidth / 2 - baseUnit / 200;
  const imgYPos = scoreYpos - decimalScoreHeight - imgDimensions.dh;

  ctx.font = mainScoreFont;
  ctx.fillText(mainScore, mainScoreXPos, scoreYpos);
  ctx.font = decimalScoreFont;
  ctx.fillText(decimalScore, decimalScoreXPos, scoreYpos);
  ctx.drawImage(img, imgXPos, imgYPos, imgDimensions.dw, imgDimensions.dh);
};

export const drawGameZone = ({
  ctx,
  x,
  y,
  radius,
  lineWidth,
  bgColor,
  canvasWidth,
  gameZoneFontSize,
  WTNlowAnimated,
  WTNHighAnimated,
  WTNlowStatic,
  WTNHighStatic,
}: {
  ctx: CanvasRenderingContext2D;
  x: number;
  y: number;
  radius: number;
  lineWidth: number;
  bgColor: string;
  canvasWidth: number;
  gameZoneFontSize: number;
  WTNlowAnimated: number;
  WTNHighAnimated: number;
  WTNlowStatic: number;
  WTNHighStatic: number;
}) => {
  ctx.font = `bold ${gameZoneFontSize}px Poppins`;
  ctx.fillStyle = "#16234c";

  const drawGameZoneLabels = ({
    lowAngle,
    highAngle,
  }: {
    lowAngle: number;
    highAngle: number;
  }) => {
    const textRadius = radius + lineWidth - lineWidth / 10;

    if (lowAngle > Math.PI + Math.PI / 2) {
      ctx.textAlign = "left";
    } else {
      ctx.textAlign = "right";
    }
    ctx.fillText(
      roundDownWTN({ wtn: WTNlowAnimated, decimalPoints: 1 }),
      polarToCartesian({ r: textRadius, angle: lowAngle }).x + canvasWidth / 2,
      polarToCartesian({ r: textRadius, angle: lowAngle }).y + canvasWidth / 2
    );

    if (highAngle > Math.PI + Math.PI / 2) {
      ctx.textAlign = "left";
    } else {
      ctx.textAlign = "right";
    }
    ctx.fillText(
      roundDownWTN({ wtn: WTNHighAnimated, decimalPoints: 1 }),
      polarToCartesian({ r: textRadius, angle: highAngle }).x + canvasWidth / 2,
      polarToCartesian({ r: textRadius, angle: highAngle }).y + canvasWidth / 2
    );
    ctx.textAlign = "center";
  };

  const drawGameZoneArc = ({
    angleStart,
    angleFinish,
  }: {
    angleStart: number;
    angleFinish: number;
  }) => {
    ctx.beginPath();
    ctx.strokeStyle = bgColor;
    ctx.lineWidth = lineWidth;
    ctx.arc(x, y, radius, angleStart, angleFinish);
    ctx.stroke();
  };

  const drawGameZoneText = ({
    letter,
    angle,
    fontSize,
    textYpos,
  }: {
    letter: string;
    angle: number;
    fontSize: number;
    textYpos: "up" | "down";
  }) => {
    ctx.save();
    ctx.font = `bold ${fontSize}px Poppins`;
    ctx.fillStyle = "white";
    const textRadius =
      textYpos === "up"
        ? radius + (1 / 14) * lineWidth
        : radius - (1 / 3.5) * lineWidth;
    ctx.translate(
      polarToCartesian({ r: textRadius, angle }).x + canvasWidth / 2,
      polarToCartesian({ r: textRadius, angle }).y + canvasWidth / 2
    );
    ctx.rotate(Math.PI / 2 + angle);
    ctx.textAlign = "center";
    ctx.fillText(letter, 0, 0);
    ctx.restore();
  };

  if (
    WTNlowStatic > WTNHighStatic &&
    WTNlowStatic >= 1 &&
    WTNlowStatic <= 40 &&
    WTNHighStatic >= 1 &&
    WTNHighStatic <= 40
  ) {
    const gameZoneStartingAngle = mapRange({
      value: WTNlowStatic,
      low1: 40,
      high1: 1,
      low2: Math.PI / 2 + Math.PI / 10,
      high2: 2 * Math.PI + Math.PI / 2 - Math.PI / 10,
    });
    const gameZoneFinishAngle = mapRange({
      value: WTNHighStatic,
      low1: 40,
      high1: 1,
      low2: Math.PI / 2 + Math.PI / 10,
      high2: 2 * Math.PI + Math.PI / 2 - Math.PI / 10,
    });
    const midAngle = (gameZoneStartingAngle + gameZoneFinishAngle) / 2;
    const fontSize = canvasWidth / 50;

    drawGameZoneLabels({
      lowAngle: gameZoneStartingAngle,
      highAngle: gameZoneFinishAngle,
    });
    drawGameZoneArc({
      angleStart: gameZoneStartingAngle,
      angleFinish: gameZoneFinishAngle,
    });

    drawGameZoneText({
      letter: "G",
      angle: midAngle - Math.PI / 29,
      fontSize,
      textYpos: "up",
    });
    drawGameZoneText({
      letter: "a",
      angle: midAngle - Math.PI / 78,
      fontSize,
      textYpos: "up",
    });
    drawGameZoneText({
      letter: "m",
      angle: midAngle + Math.PI / 80,
      fontSize,
      textYpos: "up",
    });
    drawGameZoneText({
      letter: "e",
      angle: midAngle + Math.PI / 27,
      fontSize,
      textYpos: "up",
    });

    drawGameZoneText({
      letter: "z",
      angle: midAngle - Math.PI / 33,
      fontSize,
      textYpos: "down",
    });
    drawGameZoneText({
      letter: "O",
      angle: midAngle - Math.PI / 110,
      fontSize,
      textYpos: "down",
    });
    drawGameZoneText({
      letter: "N",
      angle: midAngle + Math.PI / 72,
      fontSize,
      textYpos: "down",
    });
    drawGameZoneText({
      letter: "e",
      angle: midAngle + Math.PI / 28.5,
      fontSize,
      textYpos: "down",
    });
  }
};
